export default __webpack_public_path__ + "static/media/quesIcon.164d22e0.svg";